import React from 'react';
import { ServiceDetail } from '../../../constants'; // Make sure this is correctly imported
import styles from './serviceDetailSec.module.css';
import ServiceDetailBanner from './ServiceDetailBanner';
import ServiceDetailVideo from './ServiceDetailVideo';
import ServiceDetailServiceList from './ServiceDetailServiceList';
import ServiceDetailMarque from './ServiceDetailMarque';
import ServiceDetailContact from './ServiceDetailContact';
import { IMAGE_URL } from '../../helpers/api_helper';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_EN } from '../../helpers/constant';

const ServiceDetailSec = ({ serviceD, partnerData, configData }) => {
    const services = serviceD;
    const { t, i18n } = useTranslation();
    

    return (
        <div className={styles.ServiceDetailSec}>
            <ServiceDetailBanner
                /* title={serviceD.title}
                disc={serviceD.description} */

                title={i18n.language === LANG_EN ? serviceD.title : serviceD.titleAr}
                disc={i18n.language === LANG_EN ? serviceD.description : serviceD.descriptionAr}

                img={`${IMAGE_URL}/whatWeDo/${serviceD.image}`}
            />
            {/* <ServiceDetailVideo svideo={serviceD.video} /> */}
            <ServiceDetailServiceList servicelist={services.features} />
            {partnerData && (
                <ServiceDetailMarque partnerData = {partnerData}/>
            )}
            
            <ServiceDetailContact configData = {configData}/>
        </div>
    );
};

export default ServiceDetailSec;
